import { useEffect, useState } from 'react'
import { Loading } from '@internal/ui-kit/components/admin/loading'
import { AuthError } from '@internal/ui-kit/components/admin/authentication'
import { authProvider } from '@/providers/authProvider'

/**
 * Landing page for Google's OAuth `redirect_uri`.
 *
 * This can't reuse ra-core's own `useHandleAuthCallback` (the hook behind the
 * built-in `/auth-callback` route): that route is a sibling of the admin's
 * authenticated route tree, so it can safely client-side-navigate away on
 * success. This route instead lives inside that tree (via `CustomRoutes`), so
 * a client-side navigate would leave its cached "not authenticated" auth
 * check stale and bounce straight back to /login before the token we just
 * stored is picked up. A full-page redirect avoids that, mirroring
 * `startGoogleLogin`'s own `window.location.assign` for the outbound leg.
 */
export const GoogleOAuthCallbackPage = () => {
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    authProvider
      .handleCallback!()
      .then(() => {
        window.location.assign('/')
      })
      .catch((err) => setError(err instanceof Error ? err : new Error('Google sign in failed.')))
  }, [])

  if (error) {
    return <AuthError message={error.message} />
  }
  return <Loading />
}
